export default "__VITE_ASSET__BeOFT4HU__"